import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject } from 'rxjs';
// import { environment } from 'src/environments/environment.prod';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MasterPatientsCareService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
      // "authorization":'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOnsiaWQiOjQyNDEsInJvbGUiOiJBZG1pblRlc3QiLCJwYXJlbnRfaWQiOiI0MjM4LDQyMzIsNDIyOSwxIiwidXNlcl90eXBlX2lkIjo1fSwiaWF0IjoxNjEwNjAxNTM5fQ.02Lv9P48SFmxsMEBr8X2vYBTdBi5vZpYh9ZfPBi7kio'

    })
  };
  opnNo: any;
  UPRNdata: any;
  empnNo: any;
  ipnNo: any;
  private selectedTabSubject = new BehaviorSubject<string>(null);
  selectedTab$ = this.selectedTabSubject.asObservable();
  selectedSubTab: string;
  casesheetData: any
  patienttype: any;
  patientRegistrationId: any;
  opddata: any;
  CreditApproverName: String;
  conn: any;
  dataTransfer: any
  constructor(private http: HttpClient) {

  }
  private subTabName: string;
  private topTabName: string;
// Add these methods to your MasterPatientsCareService

clearSubTabName(): void {
  this.subTabName = '';
  localStorage.removeItem('serviceTabName');
}
  setSubTab(name: string) {
    this.subTabName = name;
  }
  dataTransferBody(data: any) {
    this.dataTransfer = data
  }
  getdataTransfer() {
    return this.dataTransfer
  }
  getSubTab(): string {
    return this.subTabName;
  }
  private tabData: any = null;
  setTabData(data: any): void {
    this.tabData = data;
  }

  getTabData(): any {
    return this.tabData;
  }

  clearTabData(): void {
    this.tabData = null;
  }
  setTopTabName(name: string) {
    this.topTabName = name;
  }

  getTopTabName(): string {
    return this.topTabName;
  }
  clearTabSelections() {
    this.topTabName = null;
    this.subTabName = null;
    localStorage.removeItem('topTabName');
    localStorage.removeItem('subTabName');
  }
  getUrl(uri: any): any {
    return this.http.get(uri)
    //  .timeout(30000, new Error('delay exceeded'));
  }

  postUrl(uri: any, data: any): any {
    return this.http.post(uri, data)
    //  .timeout(30000, new Error('delay exceeded'));
  }
  setOPDdata(data) {
    this.opddata = data;
  }
  setCaseSheetData(data) {
    this.casesheetData = data
  }
  getCaseSheetData() {
    return this.casesheetData
  }
  getOPDdata() {
    return this.opddata;
  }
  setEmpnNo(empn) {
    this.empnNo = empn;
  }

  getEmpnNo() {
    return this.empnNo;
  }

  setIpnNo(ipnno) {
    this.ipnNo = ipnno;
  }

  getIpnNo() {
    return this.ipnNo;
  }

  setOpnNo(opn) {
    this.opnNo = opn;
  }
  setPtientType(type) {
    this.patienttype = type;
  }
  setRegId(RegId) {
    this.patientRegistrationId = RegId
  }
  getRegId() {
    return this.patientRegistrationId
  }

  getPtientType() {
    return this.patienttype
  }
  getOpnNo() {
    return this.opnNo;
  }

  setUPRNdata(uprn) {
    this.UPRNdata = uprn;
  }

  getUPRNdata() {
    return this.UPRNdata;
  }
  setSubTabName(subTab) {
    this.selectedSubTab = subTab;
  }
  getSubTabName() {
    return this.selectedSubTab;

  }
  setTabName(tab) {
    this.selectedTabSubject.next(tab);
  }
  getTabName() {
    return this.selectedTabSubject.value;
  }

  setCreditApproverName(data) {
    this.CreditApproverName = data;
  }
  getCreditApproverName() {
    return this.CreditApproverName;
  }

  //header data json db START
  getHeaderData(): Observable<any> {
    return this.http.get<any>('assets/tableheader/headerData.json');
  }

  //Reports API Start

  PcMisReportOpd(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcMisReportOpdApi.php', data).pipe(map(res => res));
  }

  //Reports API End
  //header data json db END

  trialbalance(data: any): Observable<any> {
    return this.postUrl(`${environment.accountingUrl}` + '/AccountsTrialBalanceApi.php', data).pipe(map(res => res));
  }
  GetServerTime(data): Observable<any> {
    return this.http.post(`${environment.configUrl}` + '/utility.php', data).pipe(map(res => res));
  }
  getDeptClassDipendancy(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/GetDepartmentClassificationApi.php').pipe(map(res => res))
  }

  addGender(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  addMaritial(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  addBloodGroup(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  addIdentity(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  addReligion(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  addState(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  getInsuranceCmp(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }

  ChronicDisease(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  getpatientsCnt(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteRegistrationApi.php', data).pipe(map(res => res));
  }

  patienteRegistration(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteRegistrationApi.php', data).pipe(map(res => res));
  }
  updatePatienteRegistration(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteRegistrationApi.php', data).pipe(map(res => res));
  }

  patienteView(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteRegistrationApi.php', data).pipe(map(res => res));
  }

  patienteViewDetails(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteRegistrationApi.php', data).pipe(map(res => res));
  }
  bloodgroupupload(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/BloodgroupvalidateApi.php', data).pipe(map(res => res));
  }
  patientType(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  patientSubType(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  patientCounselling(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientCounsellingApi.php', data).pipe(map(res => res));
  }
  EditPatientCounselling(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientCounsellingApi.php', data).pipe(map(res => res));
  }
  ViewPatientCounselling(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientCounsellingApi.php', data).pipe(map(res => res));
  }
  searchPatient(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientSearchApi.php', data).pipe(map(res => res));
  }

  GETSpecialstatus(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  getDocterName(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  getDepartmentName(id, type): Observable<any> {
    // return this.getUrl(`${environment.patapiUrl}` + '/Get_Clinical_Dept.php', data).pipe(map(res => res));
    return this.getUrl(`${environment.apiUrl}` + '/Get_Clinical_Dept.php?id=' + id + "&type=" + type);
  }
  AddOpdPatient(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientOpdTicketApi.php', data).pipe(map(res => res));
  }
   interDepartmentReferral (data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcEmpnToOpdOther.php', data).pipe(map(res => res));
  }
  UpdateOpdPatient(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientOpdTicketApi.php', data).pipe(map(res => res));
  }
  createdby(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvDepartmentRequisitionValidateApi.php', data).pipe(map(res => res));
  }
  OpdNumber(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientOpdTicketApi.php', data).pipe(map(res => res));
  }
  ViewAllOpdTicket(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientOpdTicketApi.php', data).pipe(map(res => res));
  }
  ViewForewardOpdTicket(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientOpdTicketApi.php', data).pipe(map(res => res));
  }
  patientOpdScreen(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcOpdInitialScreening.php', data).pipe(map(res => res));
  }
  editPatientOpdScreen(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcOpdInitialScreening.php', data).pipe(map(res => res));
  }
  patientSearchOPN(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientSearchApi.php', data).pipe(map(res => res));
  }
  councilingbyopdid(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientCounsellingApi.php', data).pipe(map(res => res));
  }
  screeningbyopdid(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcOpdInitialScreening.php', data).pipe(map(res => res));
  }
  PatientOPDQueing(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientQuingApi.php', data).pipe(map(res => res));
  }
  TotalPatientOPDQueing(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientQuingApi.php', data).pipe(map(res => res));
  }
  PatientOPDOtherQueing(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientOpdQueingOthersApi.php', data).pipe(map(res => res));
  }
  OpdviewApi(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientOpdTicketApi.php', data).pipe(map(res => res));
  }
  OpdScreenview(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcOpdInitialScreening.php', data).pipe(map(res => res));
  }
  getareabypin(data: any): Observable<any> {
    return this.getUrl(`${environment.patapiUrl}` + '/getAddressBasedOnPin.php?pin=' + data).pipe(map(res => res));
  }
  PcPatientOpdOtherTicket(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientOpdOtherTicketApi.php', data).pipe(map(res => res));
  }
  //OTP Validation Api Start
  OtpSend(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteMobileNumberVerificationApi.php', data).pipe(map(res => res));
  }
  OTPValidate(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteMobileNumberVerificationApi.php', data).pipe(map(res => res));
  }
  PcOpdMinorotProcedure(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcOpdMinorotProcedureApi.php', data).pipe(map(res => res));
  }
  //OTP Validation Api End

  //Doctor Consolation Api Start

  DrConsulationAdd(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcDrConsulationapi.php', data).pipe(map(res => res));
  }
  GetRadiology(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  getPathology(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  getPathologypathologydata(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  TicketReportUpdate(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcDrConsulationapi.php', data).pipe(map(res => res));
  }
  DoctorAdviceUpdate(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcDrConsulationapi.php', data).pipe(map(res => res));
  }
  IpAddmissionUpdate(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcDrConsulationapi.php', data).pipe(map(res => res));
  }
  DrConcView(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcDrConsulationapi.php', data).pipe(map(res => res));
  }
  opdcheckout(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcDrConsulationapi.php', data).pipe(map(res => res));
  }
  opdHistory(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientMasterDataApi.php', data).pipe(map(res => res));
  }
  getDeptClass(id: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientOpdTicketApi.php', id).pipe(map(res => res))
  }
  DrConsulationOPN(id: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcOpdDiagnosisReportUpload.php', id).pipe(map(res => res))
  }
  OpdipAddmission(id: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientOpdIpAdmissionApi.php', id).pipe(map(res => res))
  }
  CompMediData(id: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcCompositionMedicineApi.php', id).pipe(map(res => res))
  }

  //Doctor Consolation Api End

  //Master Data Api Start
  patientopddata(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientMasterDataApi.php', data).pipe(map(res => res));
  }
  //Master Data Api End

  //doctor schedule Api start
  GetDoctorDetails(): Observable<any> {
    return this.http.get(`${environment.apiUrl}` + '/View_Profile_ByUserid.php?userId=' + localStorage.getItem('userId')).pipe(map(res => res))
  }
  //doctor schedule Api End

  //EMPN API START

  AddEmpnPatient(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientTicketRegistrationEmpnApi.php', data).pipe(map(res => res));
  }
  AddEmpnMLCPatient(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteMlcStatusUpadateApiEmpn.php', data).pipe(map(res => res));
  }
  EditEmpnPatient(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientTicketRegistrationEmpnApi.php', data).pipe(map(res => res));
  }
  ViewEmpnPatient(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientTicketRegistrationEmpnApi.php', data).pipe(map(res => res));
  }
  EmpnNo(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientTicketRegistrationEmpnApi.php', data).pipe(map(res => res));
  }
  ViewAllEmpnNo(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientTicketRegistrationEmpnApi.php', data).pipe(map(res => res));
  }
  ViewEmpnNo(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientTicketRegistrationEmpnApi.php', data).pipe(map(res => res));
  }
  AddEmpnScreen(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientEmpnInitialScreeningApi.php', data).pipe(map(res => res));
  }
  EditEmpnScreen(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientEmpnInitialScreeningApi.php', data).pipe(map(res => res));
  }
  ViewEmpnScreen(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientEmpnInitialScreeningApi.php', data).pipe(map(res => res));
  }
  SearchEmpn(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientSearchApi.php', data).pipe(map(res => res));
  }
  ViewAllEmpnScreen(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientEmpnInitialScreeningApi.php', data).pipe(map(res => res));
  }
  DrConsulationEmpn(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientEmpnDrConsulationApi.php', data).pipe(map(res => res));
  }
  DrConsulationEmpnView(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientEmpnDrConsulationApi.php', data).pipe(map(res => res));
  }
  getDoctor(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientTicketRegistrationEmpnApi.php', data).pipe(map(res => res));
  }
  getEmpnStatus(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientTicketRegistrationEmpnApi.php', data).pipe(map(res => res));
  }
  getEmpnMLCStatus(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientTicketRegistrationEmpnApi.php', data).pipe(map(res => res));
  }
  patientEmpnData(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientMasterDataApi.php', data).pipe(map(res => res));
  }
  patientIpnData(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientMasterDataApi.php', data).pipe(map(res => res));
  }
  EmpnHistory(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientMasterDataApi.php', data).pipe(map(res => res));
  }
  EmpnDrConcView(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientEmpnDrConsulationApi.php', data).pipe(map(res => res));
  }
  EmpnMlcSattus(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/EmpnMlcStatusApi.php', data).pipe(map(res => res));
  }
  IpnMlcSattus(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/IpnMlcStatusApi.php', data).pipe(map(res => res));
  }
  DiagnosisReport(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientDiagnosisReportApi.php', data).pipe(map(res => res));
  }
  EmpnTreatmentStatus(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientEmpnTreatmentStatusApi.php', data).pipe(map(res => res));
  }
  EmpnIpAddmission(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientEmpnTreatmentIpAdmissionApi.php', data).pipe(map(res => res));
  }
  radiologyPathologyTestStatus(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  DiagnosisReportStatus(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcOpdDiagnosisReportUpload.php', data).pipe(map(res => res));
  }
  Uploadfile(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcRegistrationDocumentUploadfileApi.php', data).pipe(map(res => res));
  }
  bedAllotment(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientEmpnBedAllotmentApi.php', data).pipe(map(res => res));
  }
  PatientDignosticRequestView(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientDignosticRequestViewApi.php', data).pipe(map(res => res));
  }
  serviceSubCategory(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminServiceSubcategoryApi.php', data).pipe(map(res => res));
  }
  DischargeParticulars(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/DischargeEmpnAndIpn.php', data).pipe(map(res => res));

  }
    DischargeSummary(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/DischargeSummary.php', data).pipe(map(res => res));

  }
  DignosticTrackerSearch(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/DignosticTrackerSearch.php', data).pipe(map(res => res));
  }

  //EMPN API END


  //Billing API Start 
  Discharge(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientDischargeApi.php', data).pipe(map(res => res));
  }
  billsettlement(data: any): Observable<any> {
        return this.postUrl(`${environment.patapiUrl}` + '/Billing/CashBillingSettlement.php', data).pipe(map(res => res));
  }
  MrdProcess(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/MrdProcessTrackerApi.php', data).pipe(map(res => res));
  }
  MrdProcessNew(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/MrdProcessTrackerNewApi.php', data).pipe(map(res => res));
  }

  MastercardBill(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/InvoiceReceiptApi.php', data).pipe(map(res => res));
  }
  AddInvoice(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/InvoiceReceiptApi.php', data).pipe(map(res => res));
  }
  InvoicePrint(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/InvoicePrintReceiptApi.php', data).pipe(map(res => res));
  }

  ServiceCategory(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminServiceCategoryApi.php', data).pipe(map(res => res));
  }
  Servicedetails(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminServiceItemApi.php', data).pipe(map(res => res));
  }
  Cashbilling(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/CashBillingDetailsApi.php', data).pipe(map(res => res));
  }
    CashBillingDetailsAddNewApi(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/CashBillingDetailsAddNewApi.php', data).pipe(map(res => res));
  }
  Creditbilling(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/CreditBillingDetailsApi.php', data).pipe(map(res => res));
  }
  Creditbillingapproval(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/CreditBillingBalanceApi.php', data).pipe(map(res => res));
  }
  CreditbillView(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/CreditBillingBalanceApi.php', data).pipe(map(res => res));
  }
  PatientCreditLimit(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/PatientCreditLimitApi.php', data).pipe(map(res => res));
  }
  InsuranceInitialApproval(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/InsuranceBillingInitialApprovalApi.php', data).pipe(map(res => res));
  }
  InsuranceBillingInitialCredit(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/InsuranceBillingInitialCreditApprovalApi.php', data).pipe(map(res => res));
  }
  InsuranceBilling(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/InsurancetBillingDetailsApi.php', data).pipe(map(res => res));
  }
  BskyCardBlock(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/BskyCardBlockApi.php', data).pipe(map(res => res));
  }
  BskyCreditLimit(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/BskyCreditLimitApi.php', data).pipe(map(res => res));
  }
  BskyInternalBilling(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/BskyInternalBillingApi.php', data).pipe(map(res => res));
  }
  BskyCardRelease(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/BskyCardReleaseApi.php', data).pipe(map(res => res));
  }
  BskyGovtBIlling(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/BskyBIllingApi.php', data).pipe(map(res => res));
  }

  //Corporate  API Start 
  CorpCaseReg(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/CorpCaseRegApi.php', data).pipe(map(res => res));
  }
  CorpCreditLimit(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/CorpCreditLimitApi.php', data).pipe(map(res => res));
  }
  CorporateInternalBilling(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/CorporateCashBillingApi.php', data).pipe(map(res => res));
  }
  CorpCashFinal(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/CorpCashFinalSubmitApi.php', data).pipe(map(res => res));
  }
  CorporateCaseQuery(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/CorporateCaseQueryClearanceApi.php', data).pipe(map(res => res));
  }
  //Corporate API End 

  //Billing API End 

  Pcdoctor(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcdoctorApi.php', data).pipe(map(res => res));
  }

  //IPN API START

  IpnRegistrationApi(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientIpnRegistrationApi.php', data).pipe(map(res => res));
  }
  IpnInitialAssessmentApi(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcIpdInitialAssessmentApi.php', data).pipe(map(res => res));
  }
  AdmissionConsentForm(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/IpdConsetMasterApi.php', data).pipe(map(res => res));
  }
  IpdInitialNursing(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/IpdInitialNursingAssessmentApi.php', data).pipe(map(res => res));
  }
  PcIpdDrobervation(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcIpdDrobervationApi.php', data).pipe(map(res => res));
  }
  AccomadationMaster(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/Pc_AccomandationApi.php', data).pipe(map(res => res));
  }

  ipDClinicalRecord(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcIpdClinicalRecordFileApi.php', data).pipe(map(res => res));
  }
  pcIpdPlanOfCare(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/pcIpdPlanOfCareApi.php', data).pipe(map(res => res));
  }
  pcDentalPlanOfCare(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/pcPlanOfCareDentalApi.php', data).pipe(map(res => res));
  }
  subDepartment(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/SubDepartmentApi.php', data).pipe(map(res => res));
  }
  IpdBedAccomodation(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcIpdBedAccomodationApi.php', data).pipe(map(res => res));
  }
  IpnDischargeAdvice(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientIpnDischargeAdviceApi.php', data).pipe(map(res => res));
  }
  IpnDischarge(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientIpnDischargeApi.php', data).pipe(map(res => res));
  }
  IpntreatmentProgress(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/IpntreatmentprocessprogressreportApi.php', data).pipe(map(res => res));
  }
  Ipndietaryplan(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/IpndietaryplanApi.php', data).pipe(map(res => res));
  }
  Ipnservicerequestfordoctor(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/IpnservicerequestfordoctorApi.php', data).pipe(map(res => res));
  }
  Ipntreatmentnursingvitaldetails(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/IpntreatmentnursingvitaldetailsApi.php', data).pipe(map(res => res));
  }
  EmpnNurseRecord(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/EmpnNurseRecordApi.php', data).pipe(map(res => res));
  }
  Ipntreatmentstatus(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/IpntreatmentstatusApi.php', data).pipe(map(res => res));
  }
  Ipntreatmentprocess(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/IpntreatmentprocessApi.php', data).pipe(map(res => res));
  }
  IpnDignosisReportupload(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/IpnDignosisReportuploadApi.php', data).pipe(map(res => res));
  }
  IpdMisReport(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/IpdMisReportApi.php', data).pipe(map(res => res));
  }
  consentDats(id: any): Observable<any> {
    return this.getUrl(`${environment.patapiUrl}` + '/HtmlApi.php?ipnRegistrationId=' + id).pipe(map(res => res))
  }

  //IPN API END
  getBlodGroup(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/GetBloodGroupApi.php').pipe(map(res => res))
  }

  DeptEmpAccess(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/EmployeeDepartmentAccessApi.php', data).pipe(map(res => res));
  }

  viewIPNService(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/IpnservicerequestfordoctorApi.php', data).pipe(map(res => res));
  }

  ModuleSubModuleLayrone(id: any, userId): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ModuleSubModuleLayroneApi.php?menuLinkId=' + id + '&userId=' + userId + '&roleId=' + localStorage.getItem('roleId')).pipe(map(res => res))
  }
  ModuleSubModuleLayertwo(id: any, userId): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ModuleSubModuleLayrtwoApi.php?layerOneId=' + id + '&userId=' + userId + '&roleId=' + localStorage.getItem('roleId')).pipe(map(res => res))
  }
  SrnListApiApi(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/SrnListApiApi.php', data).pipe(map(res => res));
  }
  RolewiseIcon(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/RolewiseIconApi.php', data).pipe(map(res => res));
  }
  PcPreOtProcess(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPreOtProcessApi.php', data).pipe(map(res => res));
  }
  PcduringOtProcess(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcDuringOtProcessApi.php', data).pipe(map(res => res));
  }
  PcPostOtProcess(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPostOtProcessApi.php', data).pipe(map(res => res));
  }
  PatientEmpnMinorOtProcedure(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientEmpnMinorOtProcedureApi.php', data).pipe(map(res => res));
  }
  PatientEmpnPostOtProcedure(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientEmpnPostOtProcedureApi.php', data).pipe(map(res => res));
  }
  Empndischargeadvice(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/EmpndischargeadviceApi.php', data).pipe(map(res => res));
  }
  EmpnServiceRequest(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/EmpnServiceRequestForDoctorApi.php', data).pipe(map(res => res));
  }
  EmpnTreatmentProcessProgress(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/EmpnTreatmentProcessProgressReportApi.php', data).pipe(map(res => res));
  }
  EmpnDisharge(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientDischargeApi.php', data).pipe(map(res => res));
  }
  PcMisReportEmpn(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcMisReportEmpnApi.php', data).pipe(map(res => res));
  }
  GetSingleDependancy(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/GetSingleDependancyApi.php', data).pipe(map(res => res));
  }

  MedicineTrackerApi(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/MedicineTrackerApi.php', data).pipe(map(res => res));
  }
  AccountsSubledgerpartycreateApi(data: any) {
    return this.postUrl(`${environment.accountingUrl}/AccountsSubledgerpartycreateApi.php`, data);

  }
  addAccountsOtherPayble(data: any) {
    return this.postUrl(`${environment.accountingUrl}/AccountsOtherPaybleApi.php`, data).pipe(map(res => res));
  }
  trackerview(data: any) {
    return this.postUrl(`${environment.accountingUrl}/AccountsOtherpartybillprocessApi.php`, data).pipe(map(res => res));
  }
  AccountsPartyPaybleReportsApi(data: any) {
    return this.postUrl(`${environment.accountingUrl}/AccountsPartyPaybleReportsApi.php`, data).pipe(map(res => res));
  }
  AccountsSubledgerReport(data: any) {
    return this.postUrl(`${environment.accountingUrl}/AccountsSubledgerReportApi.php`, data).pipe(map(res => res));
  }

  //mrd teansit report

  MrdpatientinfoReports(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/MrdpatientinfoReportsApi.php', data).pipe(map(res => res));
  }
  accountsPartyTransacions(data: any) {
    return this.postUrl(`${environment.accountingUrl}/AccountsPartyTransacionApi.php`, data);

  }
  hmchRealdummyReconciliation(data: any) {
    return this.postUrl(`${environment.patapiUrl}/HmchRealdummyReconciliation.php`, data);

  }


  // dental api 
  DentalConsentMaster(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/DentalConsentMasterApi.php', data).pipe(map(res => res));
  }
  PcInitialScreening(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcInitialScreeningApi.php', data).pipe(map(res => res));
  }
  pcPlanOfCareDentalDepartmentwise(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/pcPlanOfCareDentalDepartmentwiseApi.php', data).pipe(map(res => res));
  }

  PcDrobservation(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcDrobservationApi.php', data).pipe(map(res => res));
  }

  PatientDPPDQueing(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcPatientQuingDppnApi.php', data).pipe(map(res => res));
  }
  DopdDupCreationProc(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/DopdDupCreationProcApi.php', data).pipe(map(res => res));
  }
  hmchDupTicketCreation(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/HmchDupTicketCreation.php', data).pipe(map(res => res));
  }
    Patadvtransactionapi(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/Patadvtransactionapi.php', data).pipe(map(res => res));
  }
   PcB2bAgency(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcB2bAgencyApi.php', data).pipe(map(res => res));
  }
  serviceTaxslab(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminServiceTaxslab.php', data).pipe(map(res => res));
  }

  IpdInitialNursingAssessmentApi(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/IpdInitialNursingAssessmentApi.php', data).pipe(map(res => res));
  }
    MrdReports(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/MrdReports.php', data).pipe(map(res => res));
  }
      MrdReportsOther(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/MrdReportsOther.php', data).pipe(map(res => res));
  }
    ServiceStatusView(data: any): Observable<any> {
    return this.postUrl(`${environment.Dothealth}` + '/ServiceStatusView', data).pipe(map(res => res))

  }
      RequestForReport(data: any): Observable<any> {
    return this.postUrl(`${environment.Dothealth}` + '/RequestForReport', data).pipe(map(res => res))

  }
  PatientIntimation(data:any): Observable<any>{
    return this.postUrl(`${environment.patapiUrl}` + '/PatientIntimation.php', data).pipe(map(res => res))
  }
    DothealthLog(data:any): Observable<any>{
    return this.postUrl(`${environment.Dothealth}` + '/DothealthLog', data).pipe(map(res => res))
  }
    PharmacyClearanceApi(data:any): Observable<any>{
    return this.postUrl(`${environment.patapiUrl}` + '/PharmacyClearanceApi.php', data).pipe(map(res => res))
  }
      getBedShiftReport(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/MrdReports.php', data).pipe(map(res => res));
  }
   EditPatientInfo(data: any): Observable<any> {
    return this.postUrl(`${environment.Dothealth}` + '/EditPatientInfo', data).pipe(map(res => res))

  }
        PatientVisitorsApi(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientVisitorsApi.php', data).pipe(map(res => res));
  }
         DignosticTrackerSearchDocSubmit(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/DignosticTrackerSearchDocSubmit.php', data).pipe(map(res => res));
  }
  searchPatientByAadhaar(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/searchPatientByAadhaar.php', data).pipe(map(res => res));
  }
         MISReportApi(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/MISReportApi.php', data).pipe(map(res => res));
  }
      OpdDistribution(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/OpdDistributionDepartmentWise.php', data).pipe(map(res => res));
  }
   HmchFakeTicket(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/HmchFakeTicketCreation.php', data).pipe(map(res => res));
  }
    DeptWiseBusiniess(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/DeptWiseBusiniess.php', data).pipe(map(res => res));
  }
      BillingSummary(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/BillingSummary.php', data).pipe(map(res => res));
  }
      getDeathDetailsReport(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/MrdReports.php', data).pipe(map(res => res));
  }
      pcActiveInpatient(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcActiveInpatient.php', data).pipe(map(res => res));
  }
}